import styled from "styled-components";

const StyledForm = styled.section`
  & {
    position: relative;
  }
  & .form-header {
    background: #1a0863;
    border-radius: 0px 0px 28px 28px;
    font-weight: 500;
    font-size: 28px;
    line-height: 42px;
    text-align: center;
    color: #ffffff;
    padding-block: 0.5rem;
    margin-top: 0.25rem;
  }

  .modal & .form-header {
    margin-top: 0;
  }
  & .form-bg {
    background: #e5e1e1;
  }
  & .form-subheader {
    font-weight: 600;
    font-size: 22px;
    line-height: 33px;
    text-align: center;
    color: #931668;
    margin-block: 1.5rem;
  }
  & .blg-row-1 .form-group {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
    position: relative; /* Ensure relative positioning for label placement */
  }
  & .blg-col-0 {
    display: none;
  }
  & .blg-row-1 .form-control::placeholder {
    opacity: 0;
  }

  & .blg-row-1 .form-control {
    box-sizing: border-box;
    padding: 20px;
    gap: 10px;
    border-radius: 5px;
    margin-bottom: 0.25rem;
    height: 3.5rem !important;
  }

  & .blg-row-1 .form-control:is(:focus, :active, :not(:placeholder-shown)) {
    background: transparent;
    border: 1px solid #f26f24 !important;
    outline: none;
    box-shadow: none;
  }
  
  /* Custom label styling */
  & .custom-label-form {
    position: absolute;
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;
    color: #999999;
    transition: 0.2s transform, 0.2s font-size, 0.2s color;
    background: white;
    padding-inline: 0.35rem;
    margin-left: 1rem;
    transform: translate(0, 1.2rem);
    border-radius: 2px;
    pointer-events: none;
    z-index: 1; /* Ensure labels appear above inputs */
  }
  
  & .custom-label-form.active {
    transform: translate(5px, -0.65rem);
    font-size: 12px;
    color: #1a0863;
  }
  
  /* Removed styles for .label-form since we're not using it anymore */
  
  & .blg-row-1 .invalid-feedback {
    margin-top: 0;
    margin-bottom: 4px;
  }

  & .blg-row-1 .blg-col-5 {
    display: none !important;
  }
  & .consent-font {
    font-weight: 400;
    font-size: 11px;
    line-height: 16px;
    text-align: justify;
    color: #666666;
  }
  & .blg-col-11 .divflex {
    flex-direction: row !important;
  }
  & .mainBtnDiv {
    width: 100%;
    position: relative !important;
  }
  & .mainBtnDiv .btn-submit {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    padding: 10px 20px;
    gap: 8px;
    background: #1a0863;
    border: none;
    outline: none;
    box-shadow: none;

    border-radius: 4px;
    width: 100%;
    font-size: 14px;
  }
  & .fine-print {
    font-weight: 400;
    font-size: 10px;
    line-height: 15px;
    text-align: justify;
    color: #000000;

    margin-block-end: 0;
  }
  & .fine-print-link {
    text-decoration: none;
  }
  & .fine-print-pad {
    padding-block: 1rem;
  }
  .modal & .fine-print-pad {
    display: none;
  }
  #message.form-control {
    height: 108px !important;
  }
  .contact & .close-button {
    display: none;
  }
  .modal & .close-button {
    font-size: 25px;
    display: flex;
    justify-content: center;
    align-items: center;
    padding-inline: 0.7rem;
    padding-block: 0.4rem;
    line-height:100%;
    position: absolute;
    right: -0.5rem;
    top: -0.5rem;
    background: #ffffff;
    border-radius: 50%;
    transform: rotate(45deg);
    cursor: pointer;
    border:1px solid gray;
  }
  .modal & {
    border-radius: 14px;
    margin-bottom: 0;
    width: auto;
    max-width: 100%;
    margin: 0 auto;
  }

  .modal & .form-bg {
    padding-top: 0;
    border-radius: 14px;
  }

  /* Added this rule to target modal-content */
  .modal-content {
    width: auto !important;
  }

  @media only screen and (min-width: 992px) {
    & .form-bg {
      background: #f5f5f5;
      padding-top: 3rem;
    }
    .modal & .form-bg {
      background: #e5e1e1;
    }

    & .form-header {
      margin-top: 0;
      margin-bottom: 3rem;
      width: fit-content;
      margin-inline: auto;
      width: 350px;
      font-size: 28px;
    }

    & .wholeform {
      margin-top: 3rem;
      background: #ffffff;
      margin-bottom: 2rem;
      box-shadow: 0px 4px 57px rgba(0, 0, 0, 0.25);
      border-radius: 14px;
    }
    .modal & .wholeform {
      background: unset;
      margin: 0rem;
    }

    & .blg-row-1 .form-control {
      background: #f5f5f5;
    }

    & .blg-row-1 .form-control:is(:focus, :active, :not(:placeholder-shown)) {
      background: white;
      border: 1px solid #f26f24 !important;
      outline: none;
      box-shadow: none;
    }
    
    /* Update background for custom labels in desktop view */
    & .custom-label-form {
      background: #f5f5f5;
    }
    
    & .custom-label-form.active {
      background: white;
    }
    
    & .fine-print {
      font-size: 15px;
      line-height: 22px;
    }

    .modal & .consent-font {
      font-weight: 400;
      font-size: 11px;
      line-height: 16px;
      text-align: justify;
      color: #666666;
    }

    /* Add media query specific rule */
    .modal-content {
      width: auto !important;
    }
  }
  @media only screen and (min-width: 1200px) {
    & .consent-font {
      font-size: 15px;
      line-height: 20px;
    }
    
    /* Also add rule at large screen size */
    .modal-content {
      width: auto !important;
    }
  }
`;
export default StyledForm;